
import { motion } from "framer-motion";
import { Heart, Clock, Shield, CheckCircle } from "lucide-react";

export const WeddingLoanOptions = () => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      custom={6}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: (i: number) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: i * 0.1,
            duration: 0.5,
          }
        })
      }}
      className="mb-12"
    >
      <div className="bg-white rounded-lg p-6 shadow-md border border-pink-100">
        <h2 className="text-2xl font-bold text-pink-700 mb-6 flex items-center">
          <Heart className="mr-2 text-pink-500" />
          Häälainan edut
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-gradient-to-r from-pink-50 to-pink-100 p-4 rounded-lg">
            <div className="flex items-start mb-2">
              <CheckCircle className="h-6 w-6 text-pink-500 mr-2" />
              <h3 className="font-semibold text-pink-700">Joustava lainamäärä</h3>
            </div>
            <p className="text-gray-700 ml-8">
              Voit hakea juuri tarvitsemasi suuruisen lainan häiden budjetin mukaan, 
              aina 5 000 eurosta 50 000 euroon.
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-pink-50 to-pink-100 p-4 rounded-lg">
            <div className="flex items-start mb-2">
              <Clock className="h-6 w-6 text-pink-500 mr-2" />
              <h3 className="font-semibold text-pink-700">Sopiva maksuaika</h3>
            </div>
            <p className="text-gray-700 ml-8">
              Valitse itsellesi sopiva maksuaika 1-15 vuoden väliltä. Pidemmällä maksuajalla 
              kuukausierä pysyy pienempänä.
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-pink-50 to-pink-100 p-4 rounded-lg">
            <div className="flex items-start mb-2">
              <Shield className="h-6 w-6 text-pink-500 mr-2" />
              <h3 className="font-semibold text-pink-700">Ei vaadi vakuuksia</h3>
            </div>
            <p className="text-gray-700 ml-8">
              Häälaina ei vaadi vakuuksia tai takaajia. Riittää, että tulotasosi 
              on riittävä lainan takaisinmaksuun.
            </p>
          </div>
          
          <div className="bg-gradient-to-r from-pink-50 to-pink-100 p-4 rounded-lg">
            <div className="flex items-start mb-2">
              <CheckCircle className="h-6 w-6 text-pink-500 mr-2" />
              <h3 className="font-semibold text-pink-700">Nopea käsittely</h3>
            </div>
            <p className="text-gray-700 ml-8">
              Saat lainapäätöksen nopeasti, jopa saman päivän aikana. Rahat tilille 
              parhaimmillaan seuraavana pankkipäivänä.
            </p>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-pink-600 to-pink-700 text-white p-5 rounded-lg">
          <h3 className="text-xl font-bold mb-2">Miksi valita häälaina?</h3>
          <p className="mb-4">
            Häiden järjestäminen on yksi elämäsi tärkeimmistä hetkistä, eikä budjetin pitäisi rajoittaa unelmiasi. 
            Häälaina tarjoaa seuraavanlaisia etuja:
          </p>
          <ul className="space-y-2 mb-4">
            <li className="flex items-center">
              <CheckCircle className="h-5 w-5 mr-2 text-pink-200" />
              <span>Kaikki hääkulut yhdellä rahoituksella</span>
            </li>
            <li className="flex items-center">
              <CheckCircle className="h-5 w-5 mr-2 text-pink-200" />
              <span>Yksi selkeä kuukausierä budjetointia varten</span>
            </li>
            <li className="flex items-center">
              <CheckCircle className="h-5 w-5 mr-2 text-pink-200" />
              <span>Mahdollisuus järjestää unelmiesi häät ilman kompromisseja</span>
            </li>
            <li className="flex items-center">
              <CheckCircle className="h-5 w-5 mr-2 text-pink-200" />
              <span>Ei tarvetta käyttää säästöjä tai luottokortteja</span>
            </li>
          </ul>
        </div>
      </div>
    </motion.div>
  );
};
